import React, { useState, useContext, useCallback } from "react";
import styled from "styled-components";
import Color from "color";
import Axios from "axios";
import { useSnackbar } from "notistack";
import { useDropzone } from "react-dropzone";
import FormData from "form-data";
import { Typography, useTheme, Grid, Icon } from "@material-ui/core";
import HelpIcon from "@material-ui/icons/Help";
import Spinner from "../ui/Spinner";
import { ZipFileHelp } from "./ZipFileHelp";
import { Button } from "../ui/forms/Button";
import { DatabaseContext } from "../../contexts/DatabaseContext";
import { UserContext } from "../../contexts/UserContext";
import FileCopyIcon from "@material-ui/icons/FileCopy";

const PhotoImport = () => {
  const [File, setFile] = useState([]);
  const [uploadProgress, setUploadProgress] = useState(null);
  const [helpWindow, setHelpWindow] = useState(false);
  const { apiUrl } = useContext(DatabaseContext);
  const { Site } = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();
  const { palette } = useTheme();

  const patron =
    Site.siteType === 0 || Site.siteType === 5 ? "Student" : "Staff";

  const onDrop = useCallback((acceptedFiles) => {
    setFile(acceptedFiles);
  }, []);
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const sendPhotos = async () => {
    let form = new FormData();
    //form.append('file', File);
    for (let i = 0; i < File.length; i++) {
      form.append(`photo${[JSON.parse[i]]}`, File[i]);
    }

    if (File.length > 0) {
      await Axios.post(
        `${apiUrl}/api/patrons/${Site.siteCode}/import/photos`,
        form,
        {
          onUploadProgress: (progressEvent) => {
            setUploadProgress(
              parseInt(
                Math.round((progressEvent.loaded / progressEvent.total) * 100),
              ),
            );
          },
        },
      )
        .then((res) => {
          if (res.data.success) {
            enqueueSnackbar("Uploaded photos", { variant: "success" });
            setUploadProgress(null);
            setFile([]);
          }
        })
        .catch((err) => {
          enqueueSnackbar(`Error uploading files: ${err.message}`, {
            variant: "error",
            autoHideDuration: 6000,
            style: { fontSize: "16px" },
          });
          setUploadProgress(null);
          setFile([]);
        });
    } else {
      enqueueSnackbar(`Error uploading files: No Files Selected`, {
        variant: "error",
        autoHideDuration: 6000,
        style: { fontSize: "16px" },
      });
      setUploadProgress(null);
      setFile([]);
    }
  };

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item md={4}>
          <DropzoneContainer {...getRootProps()}>
            <input {...getInputProps()} accept="file" />
            <Dropzone isDrag={isDragActive} colour={palette.success.main}>
              {uploadProgress > 0 ? (
                <Spinner
                  colour="success"
                  variant="determinate"
                  value={uploadProgress}
                />
              ) : (
                <></>
                //<Icon
                //icon={isDragActive ? ArrowDownward : InsertDriveFile}
                //size='4x'
                //style={{ marginBottom: '2rem' }}
                ///>
              )}
              <FileCopyIcon style={iconStyles} />
              <br />
              {File.length && !uploadProgress > 0 ? (
                <Text style={{ color: "yellow" }}>
                  {File.length} Photo files have been selected.
                </Text>
              ) : (
                <></>
              )}
              <Text>
                {!uploadProgress &&
                  "Drag and drop .jpg photos here, or click to select photos from file"}
              </Text>
            </Dropzone>
          </DropzoneContainer>
        </Grid>
        <Grid item md={8}>
          <Info>
            <Text variant="h4" gutterBottom>
              IMPORTANT INFO (Max. Photos 1000 per Import)
            </Text>
            {/* <Text>
              Please create a .zip file containing all of the photos to be
              imported, named as described below.
            </Text> */}
            <Text>
              Please Note: Your photos must be named as the {patron} ID.
            </Text>
            <Text>
              Example: <Example>123456.jpg</Example>
            </Text>
            <Text>
              You will receive a message at the bottom left of the screen when
              your photos have been resized and uploaded.
            </Text>
          </Info>
        </Grid>
      </Grid>
      <Actions>
        <Button colour="success" margin="0 1rem 0 0" onClick={sendPhotos}>
          Import Photos
        </Button>
        <Button
          colour="error"
          margin="0 1rem 0 0"
          onClick={() => {
            setUploadProgress(null);
            setFile([]);
          }}
        >
          Clear Photos
        </Button>
        {/* <Button
          colour='info'
          margin='0 1rem 0 0'
          onClick={() => setHelpWindow(true)}
        >
          <HelpIcon style={hiconStyle} />
          Help with creating zip file
        </Button> */}
      </Actions>
      {/* <ZipFileHelp open={helpWindow} close={() => setHelpWindow(false)} /> */}
    </Container>
  );
};

const Container = styled.div`
  padding: 2rem;
`;

const DropzoneContainer = styled.div`
  display: flex;
`;

const Dropzone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: 2px ${(props) => (props.isDrag ? "dashed" : "solid")};
  border-radius: 1rem;
  padding: 2rem;
  cursor: pointer;
  &:hover {
    background: ${(props) => Color(props.colour).fade(0.8).string()};
  }
  &:active {
    background: ${(props) =>
      Color(props.colour).darken(0.9).fade(0.8).string()};
  }
`;

const Actions = styled.div`
  display: flex;
  margin-top: 2rem;
`;

const Info = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  margin-left: 2rem;
  padding: 1rem 0;
  border-radius: 1rem;
`;

const Text = styled(Typography)`
  display: flex;
  align-items: center;
`;

const Example = styled(Typography)`
  font-size: 1.8rem;
  font-family: monospace;
  padding: 0.5rem 1rem;
  margin: 1rem 0 1rem 0.5rem;
  border-radius: 3px;
  background: ${(props) => Color(props.colour).fade(0.9).string()};
`;

const iconStyles = {
  fontSize: "65px",
};

const hiconStyle = {
  fontSize: "20px",
  marginRight: "5px",
};

export default PhotoImport;
